import { FormControlLabel, Radio, RadioGroup, Stack, Typography } from "@mui/material";
import { isWhitespace, TextEditor } from "src/components";
import { FormAnswerValueDto, FormQuestionDto } from "src/http/types";

interface IProps {
  question: FormQuestionDto;
  value?: FormAnswerValueDto | null;
  onChange: (value: FormAnswerValueDto | null) => void;
  onBlur?: () => void;
  disabled?: boolean;
}

const FormQuestionInput = (props: IProps) => {
  const { typeConfig } = props.question;

  if (!typeConfig) return null;

  switch (typeConfig.type) {
    case "TextInput":
      return (
        <TextEditor
          value={props.value?.type === "TextInput" ? props.value.value : ""}
          placeholder={typeConfig.placeholder}
          readonly={props.disabled}
          onChange={(v) => props.onChange(isWhitespace(v) ? null : { type: "TextInput", value: v })}
          onBlur={(v) => {
            props.onChange(isWhitespace(v) ? null : { type: "TextInput", value: v });
            props.onBlur?.();
          }}
        />
      );

    case "MultipleChoice": {
      const currentValue = props.value?.type === "MultipleChoice" ? (props.value.value[0] ?? "") : "";
      return (
        <RadioGroup
          value={currentValue}
          onChange={(_, v) => props.onChange(currentValue === v ? null : { type: "MultipleChoice", value: [v] })}
          onBlur={props.onBlur}
        >
          {typeConfig.options.map((option) => (
            <FormControlLabel
              key={option.name}
              value={option.name}
              label={
                <Stack>
                  <Typography variant="body2">{option.name}</Typography>
                  {option.subtext && <Typography variant="body1">{option.subtext}</Typography>}
                </Stack>
              }
              disabled={props.disabled}
              control={<Radio tabIndex={1} sx={{ top: -6, mr: 0.25 }} />}
              sx={{ alignItems: "flex-start", my: 0.5 }}
            />
          ))}
        </RadioGroup>
      );
    }

    case "Range": {
      const values: number[] = [];

      for (let value = typeConfig.minValue; value <= typeConfig.maxValue; value += typeConfig.stepValue) {
        values.push(value);
      }

      const currentValue = props.value?.type === "Range" ? props.value.value : "";

      return (
        <RadioGroup
          row
          value={currentValue}
          onChange={(_, v) => props.onChange({ type: "Range", value: Number(v) })}
          onBlur={props.onBlur}
        >
          <Stack sx={{
            flexGrow: 1
          }}>
            <Stack direction="row" sx={{
              justifyContent: "space-between"
            }}>
              {values.map((value) => (
                <FormControlLabel
                  key={value}
                  value={value}
                  label=""
                  sx={{ mx: -0.5 }}
                  disabled={props.disabled}
                  control={<Radio tabIndex={1} />}
                />
              ))}
            </Stack>
            <Stack direction="row" sx={{
              justifyContent: "space-between"
            }}>
              <Typography variant="caption">{typeConfig.minLabel}</Typography>
              <Typography variant="caption">{typeConfig.maxLabel}</Typography>
            </Stack>
          </Stack>
        </RadioGroup>
      );
    }

    default: {
      console.warn(`Unsupported question type`);
      return null;
    }
  }
};

export { FormQuestionInput };
